import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Group,
  NumberFormatter,
  Select,
  SelectProps,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import {
  IconActivity,
  IconBrandVisa,
  IconCheck,
  IconCoin,
  IconDownload,
  IconCopy,
  IconEdit,
  IconEye,
  IconHandClick,
  IconMenuOrder,
  IconReload,
  IconSandbox,
  IconSearch,
  IconSquareXFilled,
  IconStatusChange,
  IconVideo,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useEffect, useMemo, useState, useTransition } from "react";

import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useDisclosure, useHotkeys, useIsFirstRender } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconBrandBootstrap, IconTimeDuration15 } from "@tabler/icons-react";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import {
  keySearchSalesOrderListV2,
  repositoryPos,
  styleTableMantine,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import useDynamicHeight from "../../../_base/component/Core/hookBase";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { SocketExtension } from "../../../_base/socket/socket";
import { CREATEORDERSUCCESS } from "../../../_base/socket/ToplicList";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import LoadingOverlayCustom from "../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { BASE_API_POS } from "../../../config";
import { _localization } from "../../../config/location";
import { green, olive_green, sky_blue } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import { SelectListItem } from "../../../model/SelectListItem";
import EmployeeModelView from "../../Organization/EmployeeView";
import DetailsSellView from "../DetailsSellView";
import CloseOrderButton from "../RetailOrder/ModalComponent/CloseOrderButton";
import SalesDeleteOrder from "../SalesDeleteOrder";
import { IconChecklist } from "@tabler/icons-react";
import { getValueById } from "../../../_base/helper/FunctionHelper";
import OrderVideoModal from "./OrderVideoModal";

// Định nghĩa đúng kiểu dữ liệu
type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const ListOrderTMDTV2 = () => {
  const navigate = useNavigate();
  const location = useLocation();

  //#region  table

  //data and fetching state
  const [isHaveNewOrder, setIsHaveNewOrder] = useState(false);
  const [data, setData] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [dataBranch, setDataBranch] = useState<SelectListItem[]>([]);
  const [listEmployeeSales, setListEmployeeSales] = useState<any[]>([]);
  const [visible, { toggle, close, open }] = useDisclosure(false);

  const dataChannel = [
    {
      text: "Lazada",
      value: "304",
    },
    {
      text: "Tiktok",
      value: "341",
    },
    {
      text: "Chat Zalo",
      value: "343",
    },
    {
      text: "Facebook",
      value: "62",
    },
    {
      text: "Shopee Mall",
      value: "63",
    },
    {
      text: "Shopee",
      value: "342",
    },
    {
      text: "Tổng đài",
      value: "66",
    },
    {
      text: "Khách đến showroom",
      value: "67",
    },
    {
      text: "Khách đặt đơn Website",
      value: "68",
    },
    {
      text: "Khách gọi điện cho nhân viên",
      value: "69",
    },
    {
      text: "Khách chat qua website",
      value: "101",
    },
  ];

  const dataStatusGeneral = [
    { label: "Kho xuất hàng", value: "KHO_XUAT_HANG" },
    { label: "Thành công", value: "THANH_CONG" },
    { label: "Test OK", value: "TEST_OK" },
    { label: "Đơn hàng hoàn thành", value: "DON_HANG_HOAN_THANH" },
    { label: "Đơn hàng tạm", value: "DON_HANG_TAM" },
    { label: "Thất bại do KH", value: "THAT_BAI_DO_KH" },
    { label: "KTKT đang kiểm tra", value: "KTKT_DANG_KIEM_TRA" },
    { label: "Đơn hàng chờ duyệt giảm", value: "DON_HANG_CHO_DUYET_GIAM" },
    { label: "Đơn chờ duyệt đổi trả", value: "DON_CHO_DUYET_DOI_TRA" },
    { label: "Đơn đã duyệt đổi trả", value: "DON_DA_DUYET_DOI_TRA" },
    { label: "GV thành công", value: "GV_THANH_CONG" },
    { label: "Nhập lại", value: "NHAP_LAI" },
    { label: "Đã phân công GV", value: "DA_PHAN_CONG_GV" },
    { label: "GV đến nơi", value: "GV_DEN_NOI" },
    { label: "GV đang giao", value: "GV_DANG_GIAO" },
    { label: "Test lỗi", value: "TEST_LOI" },
    { label: "Đã phân công KTKT", value: "DA_PHAN_CONG_KTKT" },
    { label: "Hủy phân công GV", value: "HUY_PHAN_CONG_GV" },
    { label: "Thất bại do HACOM", value: "THAT_BAI_DO_HACOM" },
    { label: "Nhập lại một phần", value: "NHAP_LAI_MOT_PHAN" },
    { label: "Đơn hàng chốt", value: "DON_HANG_CHOT" },
    { label: "Đơn hàng đã duyệt giảm", value: "DON_HANG_DA_DUYET_GIAM" },
    { label: "GV tiếp nhận", value: "GV_TIEP_NHAN" },
    { label: "GV nhập lại", value: "GV_NHAP_LAI" },
    { label: "GV nhập lại một phần", value: "GV_NHAP_LAI_MOT_PHAN" },
    { label: "GV thất bại do HACOM", value: "GV_THAT_BAI_DO_HACOM" },
    { label: "GV thất bại do KH", value: "GV_THAT_BAI_DO_KH" },
    { label: "GV nối chuyến", value: "GV_NOI_CHUYEN" },
    { label: "Hủy phân công KTKT", value: "HUY_PHAN_CONG_KTKT" },
    { label: "Có nhập lại", value: "CO_NHAP_LAI" },
    { label: "KH đã nhận", value: "DA_NHAN" },
  ];

  const checkedPinSearch = localStorage.getItem("checkedPinSearch") === "true";

  const [searchTerm, setSearchTerm] = useState<string>("");
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const _searchJson = sessionStorage.getItem(keySearchSalesOrderListV2)
    ? JSON.parse(sessionStorage.getItem(keySearchSalesOrderListV2) ?? "")
    : null;
  const firstRender = useIsFirstRender();
  //table state
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    [],
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  } as MRT_PaginationState);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const height = useDynamicHeight(370);
  const innitSearchReturn = {
    customerName: "",
    customerCode: "",
    customerTaxCode: "",
    serial: "",
    orderNumber: "",
    phone: "",
    keySearch: "",
    codeSal: "",
  };

  const idUserlogin = JSON.parse(localStorage.getItem("empId") || "{}");

  // console.log("_searchJson", _searchJson);
  const innitStateSearch = useMemo(
    () => ({
      invId:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.InvId as string)
          : "",
      invOutwardId:
        firstRender && _searchJson && checkedPinSearch
          ? _searchJson.InvOutwardId
          : "",
      customerId: firstRender && _searchJson ? _searchJson.CustomerId : "",
      StartDate:
        firstRender && _searchJson && _searchJson.StartDate && checkedPinSearch
          ? new Date(_searchJson.StartDate)
          : new Date(
              new Date(
                new Date(new Date().setDate(new Date().getDate() - 9)).setHours(
                  0,
                  0,
                  0,
                  0,
                ),
              ).getTime() +
                7 * 60 * 60 * 1000,
            ),
      EndDate:
        firstRender &&
        _searchJson &&
        checkedPinSearch &&
        _searchJson.EndDate &&
        _searchJson.EndDate != null
          ? new Date(_searchJson.EndDate)
          : new Date(
              new Date(
                new Date(new Date().setDate(new Date().getDate() + 1)).setHours(
                  0,
                  0,
                  0,
                  0,
                ),
              ).getTime() +
                7 * 60 * 60 * 1000,
            ),
      orderStatus:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.OrderStatus
          : "",
      orderType:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.OrderType
          : "",
      orderNumber:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.OrderNumber
          : "",
      paymentStatus:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.PaymentStatus
          : "",
      industry:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.Industry
          : "",
      keySearch:
        checkedPinSearch && firstRender && _searchJson && checkedPinSearch
          ? _searchJson.KeySearch
          : "",
      OutwardStatus:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.OutwardStatus
          : "",
      codeCustomer:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.CodeCustomer
          : "",
      phone:
        checkedPinSearch && firstRender && _searchJson ? _searchJson.Phone : "",
      createBy:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.CreateBy
          : "",
      //Người hưởng số
      CodeSal:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.CodeSal as string)
          : "",
      //Thời gian hoàn thành đơn
      FinishDate:
        firstRender && _searchJson && _searchJson.FinishDate && checkedPinSearch
          ? new Date(_searchJson.FinishDate)
          : null,
      //Ngày xuất kho
      OwDate:
        firstRender && _searchJson && _searchJson.OwDate && checkedPinSearch
          ? new Date(_searchJson.OwDate)
          : null,
      // Số điện thoại người bán
      SalePhone:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.SalePhone
          : "",
      // Mã voucher
      VourcherCode:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.VourcherCode
          : "",
      //Tình trạng phân công
      IsAssigned:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.IsAssigned
          : "",
      // Lọc theo kênh bán
      //Đối soát
      AttributeValue7:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.AttributeValue7
          : "",
      //Kênh bán
      saleChannelId:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.saleChannelId
          : "",
      //Trạng thái đơn hàng TMĐT
      Attribute58:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.Attribute58
          : "",
      //Trạng thái chung
      Attribute12:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.Attribute12
          : "",
    }),
    [firstRender, _searchJson],
  );

  const [searchReturn, setSearchReturn] = useState({
    ...innitSearchReturn,
  });
  const form = useForm({
    mode: "uncontrolled",
    initialValues: innitStateSearch,
  });
  // const [search, setSearch] = useState({
  //   ...innitStateSearch,
  // });
  // useEffect(() => {
  //   setSearch(innitStateSearch);
  // }, []);
  const [refreshKeySearch, setRefreshKeySearch] = useState<any>({});

  const sizeGrid = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };

  const getTextStatus = (row: any) => {
    return orderStatuses.find(
      (status) => status.value === row.original.orderStatus,
    )?.label;
  };

  //#region biến DL tĩnh
  const getShippingVendorText = (shippingVendor: string) => {
    switch (shippingVendor) {
      case "KHONG":
        return "Nhận tại cửa hàng";
      case "HACOM":
        return "Nội bộ";
      default:
        return shippingVendor;
    }
  };

  const TMDT_STATUS_MAP: Record<string | number, string> = {
    0: "Mới",
    17: "Chờ xác nhận",
    11: "Chờ hàng",
    12: "Chờ in",
    13: "Đã in",
    20: "Đã đặt hàng",
    1: "Đã xác nhận",
    8: "Đang đóng hàng",
    9: "Chờ chuyển hàng",
    2: "Đã gửi hàng",
    3: "Đã nhận",
    16: "Đã thu tiền",
    4: "Đang hoàn",
    15: "Hoàn một phần",
    5: "Đã hoàn",
    6: "Đã huỷ",
    7: "Đã xoá",
    CHO_LAY_HANG: "Chờ lấy hàng",
  };

  const getDataAtt58 = (value: string | number) => {
    if (value === null || value === undefined) return "";
    return TMDT_STATUS_MAP[value] || value;
  };

  const getDataDeliveryStatus = (value: string | null) => {
    switch (value) {
      case null:
        return "Không yêu cầu";
      case "THANH_CONG":
        return "Thành công";
      case "PHAN_CONG":
        return "Phân công";
      case "TAO_MOI":
        return "Tạo mới";
      case "THAT_BAI_DO_KH":
        return "Thất bại do khách hàng";
      case "NHAP_LAI":
        return "Nhập lại";
      case "DEN_NOI":
        return "Đến nơi";
      case "DANG_GIAO":
        return "Đang giao";
      case "DA_YEU_CAU":
        return "Đã yêu cầu";
      case "HUY_PHAN_CONG":
        return "Hủy phân công";
      case "THAT_BAI_DO_HACOM":
        return "Thất bại do HACOM";
      case "TIEP_NHAN":
        return "Tiếp nhận";
      case "NHAP_LAI_MOT_PHAN":
        return "Nhập lại một phần";
      case "NOI_CHUYEN":
        return "Nối chuyến";
    }
  };
  const orderTypes = [
    { value: "1", label: "Bán buôn", color: "yellow" },
    { value: "2", label: "Bán lẻ", color: "indigo" },
    { value: "3", label: "Đơn đổi trả", color: "green" },
    { value: "4", label: "Đơn online", color: "blue" },
  ];

  const orderStatuses = [
    { value: "DON_HANG_TAM", label: "Đơn hàng tạm" },
    { value: "DON_HANG_CHOT", label: "Đơn hàng chốt" },
    { value: "DON_HANG_CHO_DUYET_GIAM", label: "Đơn chờ duyệt giảm" },
    { value: "DON_HANG_DA_DUYET_GIAM", label: "Đơn đã duyệt giảm" },
    { value: "DON_HANG_HUY", label: "Đơn hàng hủy" },
    { value: "DON_HANG_HOAN_THANH", label: "Đơn hàng hoàn thành" },
    { value: "DON_HANG_DONG", label: "Đơn hàng đóng" },
  ];

  const warehouseStatus = [
    { value: "DA_YEU_CAU", label: "Đã yêu cầu" },
    { value: "DANG_XUAT", label: "Đang xuất" },
    { value: "DA_XUAT", label: "Đã xuất" },
    { value: "DANG_NHAP", label: "Đang nhập" },
    { value: "DA_NHAP", label: "Đã nhập" },
  ];

  // Danh sách kênh bán
  const saleChannelsList = [
    { id: 1, label: "Admin" },
    { id: 2, label: "Website" },
    { id: 10, label: "API" },
    { id: 20, label: "Facebook (Khi tạo đơn hàng từ vpage.nhanh.vn)" },
    { id: 21, label: "Instagram (Khi tạo đơn hàng từ vpage.nhanh.vn)" },
    { id: 41, label: "Lazada.vn" },
    { id: 42, label: "Shopee.vn" },
    { id: 43, label: "Sendo.vn" },
    { id: 45, label: "Tiki.vn" },
    { id: 46, label: "Zalo Shop" },
    { id: 47, label: "1Landing.vn" },
    { id: 48, label: "Tiktok Shop" },
    { id: 49, label: "Zalo OA (Khi tạo đơn hàng từ vpage.nhanh.vn)" },
    { id: 50, label: "Shopee Chat (Khi tạo đơn hàng từ vpage.nhanh.vn)" },
    { id: 51, label: "Lazada Chat (Khi tạo đơn hàng từ vpage.nhanh.vn)" },
    { id: 52, label: "Zalo cá nhân (Khi tạo đơn hàng từ vpage.nhanh.vn)" },
  ];
  // #endregion biến DL tĩnh

  // Xử lý đóng đơn
  const handleCloseOrder = async (row: any) => {
    if (!row?.id) {
      console.error("Không thể đóng đơn: Thiếu ID đơn hàng");
      return;
    }

    const reason = "T6"; // Lý do đóng đơn
    const url = `/api/v1/CreateSellItem/close?id=${row.id}&reason=${reason}`;

    try {
      const response = await repositoryPos.get(url);
      if (response?.status === 200) {
        console.log("Đơn hàng đã được đóng thành công.");
        // Thực hiện các hành động tiếp theo (ví dụ: cập nhật danh sách đơn hàng)
      } else {
        console.error(
          "Lỗi khi đóng đơn:",
          response?.data?.message || "Unknown error",
        );
      }
    } catch (error) {
      console.error("Lỗi khi gọi API đóng đơn:", error);
    }
  };

  // Xử lý thanh toán
  const handleCheckPayment = async (row: any) => {
    const url = `/api/v1/CreateSellItem/payment?orderNumber=${row.original.orderNumber}`;
    const response = await repositoryPos.get<MessageResponse<any>>(url);

    if (response && response.success) {
      // Kiểm tra nếu orderNumber chứa "DT"
      if (row.original.orderNumber.includes("DT")) {
        navigate("/sell/payment-order-return", {
          state: {
            id: row.original.id,
            orderNumber: row.original.orderNumber,
            orderType: row.original.orderType,
            actionType: "payment",
            fromTMDTList: true, // Thêm flag để nhận biết từ màn hình TMDT
          },
        });
      } else {
        navigate("/sell/payment-order", {
          state: {
            id: row.original.id,
            orderNumber: row.original.orderNumber,
            orderType: row.original.orderType,
            actionType: "payment",
            fromTMDTList: true, // Thêm flag để nhận biết từ màn hình TMDT
          },
        });
      }
    }
  };

  // Xử lý duyệt giảm giá
  const handleCheckApproved = async (row: any) => {
    const url = `/api/v1/CreateSellItem/approve?orderNumber=${row.original.orderNumber}`;
    const response = await repositoryPos.get<MessageResponse<any>>(url);
    if (response && response.success) {
      if (row.original.orderNumber.includes("DT")) {
        navigate("/sell/approved-discount-order-return", {
          state: {
            orderNumber: row.original.orderNumber,
            orderType: row.original.orderType,
            actionType: "approved",
          },
        });
      } else {
        navigate("/sell/approved-discount-order", {
          state: {
            orderNumber: row.original.orderNumber,
            orderType: row.original.orderType,
            actionType: "approved",
          },
        });
      }
    }
  };

  // Sửa đơn hàng
  const handleCheckEdit = async (row: any) => {
    // check thêm orderType
    const url = `/api/v1/CreateSellItem/edit?orderNumber=${row.original.orderNumber}`;
    const response = await repositoryPos.get<MessageResponse<any>>(url);

    if (response && response.success) {
      navigate("/sell/retail-order-tmdt", {
        state: {
          orderNumber: row.original.orderNumber,
          orderType: row.original.orderType,
          actionType: "edit",
          fromTMDTList: true, // Thêm flag để nhận biết từ màn hình TMDT
        },
      });
    }
  };

  // Xem chi tiết đơn hàng
  const handleCheckView = async (row: any) => {
    const url = `/api/v1/CreateSellItem/details?orderNumber=${row.original.orderNumber}`;
    const response = await repositoryPos.get<MessageResponse<any>>(url);
    if (response && response.success) {
      navigate("/sell/retail-order-tmdt", {
        state: {
          id: row.original.id,
          orderNumber: row.original.orderNumber,
          orderType: row.original.orderType,
          actionType: "view",
          fromTMDTList: true, // Thêm flag để nhận biết từ màn hình TMDT
        },
      });
    }
  };

  // Fetch lấy dữ liệu đơn hàng
  const fetchData = async () => {
    setIsLoading(true);
    //   setIsRefetching(true);
    // setIsError(false);

    let queryParams = {
      Skip:
        firstRender && _searchJson
          ? _searchJson.Skip
          : pagination.pageIndex * pagination.pageSize,
      Take: firstRender && _searchJson ? _searchJson.Take : pagination.pageSize,
    } as any;
    try {
      // if (!firstRender) {
      const search = form.getValues();
      queryParams = {
        ...queryParams,
        // Skip: pagination.pageIndex * pagination.pageSize,
        // Take: pagination.pageSize,
        InvId: search.invId?.toString(),
        InvOutwardId: search.invOutwardId?.toString(),
        CustomerId: search.customerId?.toString(),
        StartDate: search.StartDate
          ? moment(search?.StartDate).format("YYYY-MM-DDT00:00:00.000[Z]")
          : "",
        EndDate: search.EndDate
          ? moment(search?.EndDate).format("YYYY-MM-DDT00:00:00.000[Z]")
          : "",
        OrderStatus: search.orderStatus?.toString(),
        OrderType: search.orderType ? search.orderType?.toString() : "",
        OrderNumber: search.orderNumber?.toString(),
        PaymentStatus: search.paymentStatus?.toString(),
        industry: search.industry?.toString(),
        OutwardStatus: search?.OutwardStatus?.toString(),
        KeySearch: search.keySearch?.toString(),
        CodeCustomer: search.codeCustomer?.toString(), // Thêm trường tìm kiếm mã khách hàng
        Phone: search.phone?.toString(), // Thêm trường tìm kiếm số điện thoại
        CreateBy: search.createBy?.toString(), // Thêm trường tìm kiếm người tạo
        CodeSal: search.CodeSal?.toString(), //Thêm người hưởng số
        FinishDate: search.FinishDate
          ? moment(search?.FinishDate).format("YYYY-MM-DDT00:00:00.000[Z]")
          : "", //Thời gian hoàn thành đơn
        OwDate: search.OwDate
          ? moment(search?.OwDate).format("YYYY-MM-DDT00:00:00.000[Z]")
          : "", //ngày xuất kho
        SalePhone: search.SalePhone?.toString(), // Số điện thoại người bán
        VourcherCode: search.VourcherCode?.toString(), // Mã voucher
        saleChannelId: search.saleChannelId?.toString(),
        AttributeValue7: search.AttributeValue7?.toString(),
        Attribute58: search.Attribute58?.toString(), // Trạng thái đơn hàng TMĐT
        Attribute12: search.Attribute12?.toString(), // Trạng thái chung
      };
      // } else {
      //   const _searchJson = localStorage.getItem(keySearchSalesOrderListV2);
      //   if (_searchJson) {
      //     const _search = JSON.parse(_searchJson);
      //     if (_search) queryParams = _search;
      //   }
      // }

      const queryParamsReturn = {
        Skip: pagination.pageIndex * pagination.pageSize,
        Take: pagination.pageSize,
        CustomerName: searchReturn.customerName,
        CustomerCode: searchReturn.customerCode,
        CustomerTaxCode: searchReturn.customerTaxCode,
        Serial: searchReturn.serial,
        OrderNumber: searchReturn.orderNumber,
        Phone: searchReturn.phone,
        KeySearch: searchReturn.keySearch,
        CodeSal: searchReturn.codeSal,
        saleChannelId: search.saleChannelId,
      };

      let url;

      if (location?.pathname === "/sell/sales-order-list-read-only") {
        url =
          "/api/v1/CreateSellItem/get-list-return-sale?" +
          Object.entries({
            ...queryParamsReturn,
            Skip: pagination.pageIndex * pagination.pageSize,
            Take: pagination.pageSize,
          })
            .filter(([key, value]) => {
              // Bỏ qua các trường rỗng, trừ Skip và Take
              return (
                (value !== undefined && value !== "") ||
                key === "Skip" ||
                key === "Take"
              );
            })
            .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
            .join("&");
      } else {
        url =
          "/api/v1/CreateSellItem/get-list?IsOnline=false&IsInstallment=false&IsAccountant=false&IsEcommerce=true&" +
          Object.entries(queryParams)
            .filter(([, value]) => value !== undefined && value !== "")
            .map(
              ([key, value]) =>
                `${key}=${encodeURIComponent(
                  value as string | number | boolean,
                )}`,
            )
            .join("&");
      }
      //   console.log(queryParams);
      const response = await repositoryPos.get<MessageResponse<any>>(url);

      if (response && response.success) {
        setData(response.data?.pagedList?.lists);
        startTransition(() => {
          setRowCount(response.totalCount);
          //     table.resetRowSelection();
        });
      }
    } catch (error) {
      //   setIsError(true);
      console.error(error);
    } finally {
      setIsLoading(false);
      //   setIsRefetching(false);
      sessionStorage.setItem(
        keySearchSalesOrderListV2,
        JSON.stringify(queryParams),
      );
    }
  };

  /**
   * Chỉ đơn đã chốt sổ mới cho tạo lại. Đơn đang dở dang mà tạo lại
   * sẽ thành hai đơn cùng chạy song song cho một đơn của sàn.
   * Máy chủ cũng chặn lại lần nữa, đây chỉ để nút hiện đúng trạng thái.
   */
  const ALLOW_COPY_STATUSES = [
    "DON_HANG_HOAN_THANH",
    "DON_HANG_DONG",
    "DON_HANG_HUY",
  ];

  /**
   * Tạo lại đơn từ dữ liệu sàn đã gửi trước đó.
   *
   * Hỏi lại trước khi chạy vì thao tác này đổi mã đơn của sàn trên đơn cũ
   * và sinh ra một đơn mới - không phải việc lỡ tay bấm được.
   */
  const handleCopyOrder = (orderNumber: string) => {
    modals.openConfirmModal({
      title: <Title order={5}>Tạo lại đơn hàng</Title>,
      size: "520px",
      centered: true,
      children: (
        <Box py="md">
          <Text size="sm" lh={1.7}>
            Tạo lại đơn <b>{orderNumber}</b> từ dữ liệu sàn đã gửi trước đó ?
          </Text>
          <Text size="sm" c="dimmed" lh={1.7} mt="sm">
            Đơn hiện tại vẫn giữ nguyên, chỉ đổi mã đơn của sàn để nhường cho
            đơn mới.
          </Text>
        </Box>
      ),
      labels: { confirm: "Tạo lại", cancel: "Hủy bỏ" },
      confirmProps: { color: "blue" },
      onConfirm: async () => {
        try {
          const res = await repositoryPos.post<MessageResponse<any>>(
            `/api/v1/Ecommerce/copy-order?orderNumber=${encodeURIComponent(orderNumber)}`,
            {},
          );

          if (res && res.success) {
            NotificationExtension.Success("Tạo lại đơn hàng thành công !");
            await fetchData();
          } else {
            NotificationExtension.Fails(
              res?.message ?? "Tạo lại đơn hàng thất bại !",
            );
          }
        } catch (error) {
          console.error(error);
          NotificationExtension.Fails("Có lỗi khi tạo lại đơn hàng !");
        }
      },
    });
  };

  //Hàm hủy đơn hàng
  const DeleteCancelOrder = (value: any, status: any) => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Hủy đơn hàng!</Title>
        </>
      ),
      size: "auto",
      children: (
        <SalesDeleteOrder
          idItems={value}
          status={status}
          onSearch={fetchData}
          onClose={setDeleteViewStatus}
          web={true}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  // Xem danh sách sản phẩm trong đơn hàng
  const openModal = (document: any, amount: number, order: string) =>
    modals.openConfirmModal({
      title: <Title order={4}>Danh sách sản phẩm trong đơn: {order}</Title>,
      children: <DetailsSellView e={document} amount={amount} />,
      size: "100%",
      radius: "md",
      labels: { confirm: "Confirm", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });

  // Xem danh sách video quay lại lúc giao hàng của đơn
  const openVideoModal = (orderNumber: string) =>
    modals.openConfirmModal({
      title: <Title order={5}>Video giao hàng đơn: {orderNumber}</Title>,
      children: <OrderVideoModal orderNumber={orderNumber} />,
      size: "80%",
      radius: "md",
      centered: true,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });

  // Phân công nhân viên
  const onModalAssignNv = (orderHeaderId: number) => {
    modals.openConfirmModal({
      title: (
        <Title size="md" order={4}>
          Phân công nhân viên
        </Title>
      ),
      children: (
        <EmployeeModelView
          isOpenModal={true}
          handleAssignNv={(employeeId: number) =>
            handleAssignNv(employeeId, orderHeaderId)
          }
        />
      ),
      size: "90vw",
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  // Hàm phân công
  const handleAssignNv = async (employeeId: number, orderHeaderId: number) => {
    try {
      const response = await repositoryPos.post<MessageResponse<any>>(
        `/api/v1/CreateSellItem/assign?OrderHeaderId=${orderHeaderId}&EmployeeId=${employeeId}`,
      );
      if (response && response.success) {
        NotificationExtension.Success("Phân công thành công");
      } else {
        NotificationExtension.Fails("Phân công thất bại");
      }
    } catch (error) {
      console.log("error:", error);
    } finally {
      modals.closeAll();
      setTimeout(() => {
        fetchData();
      }, 500);
    }
  };

  // NHân viên tiếp nhận
  const handleAcceptNV = async (orderHeaderId: number) => {
    try {
      const response = await repositoryPos.post<MessageResponse<any>>(
        `/api/v1/CreateSellItem/accept?OrderHeaderId=${orderHeaderId}`,
      );
      if (response && response.success) {
        NotificationExtension.Success("Tiếp nhận thành công");
        setTimeout(() => {
          fetchData();
        }, 500);
      }
    } catch (error) {
      console.log("error:", error);
    }
  };

  const handleSearchChange = (value: string) => {
    setSearchTerm(value);
  };

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 80,
        // enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        enableColumnFilters: false,
      },
      {
        accessorKey: "orderNumber",
        header: "Mã đơn hàng",
        // // enableColumnActions: false,,
        enableColumnFilter: false,
        size: 160,
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label="Xem chi tiết">
            <Badge
              radius="sm"
              variant="dot"
              size="md"
              style={{ cursor: "pointer" }}
              color={renderedCellValue === null ? "red" : green.base}
              onDoubleClick={() => handleCheckView(row)}
            >
              {renderedCellValue === null ? "KHÔNG HỢP LỆ" : renderedCellValue}
            </Badge>
          </Tooltip>
        ),
      },
      {
        accessorKey: "attribute49",
        header: "Mã đơn hàng kênh bán",
        size: 200,
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "attribute82",
        header: "Mã vận đơn",
        size: 200,
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      // {
      //   accessorKey: "attribute74",
      //   header: "Kênh bán",
      //   size: 150,
      //   enableColumnFilter: false,
      //   Cell: ({ row }) => {
      //     const found = saleChannelsList.find(
      //       (c) => c.id === Number(row.original.attribute74)
      //     );
      //     return found ? found.label : row.original.attribute74;
      //   },
      // },
      {
        accessorKey: "orderStatus",
        header: "Trạng thái đơn hàng",
        // // enableColumnActions: false,,
        enableColumnFilter: false,
        size: 200,
        Cell: ({ row }) => {
          const orderStatus = row.original.orderStatus;
          let badgeColor;
          switch (orderStatus) {
            case "DON_HANG_TAM":
              badgeColor = "cyan";
              break;
            case "DON_HANG_CHOT":
              badgeColor = "violet";
              break;
            case "DON_HANG_DOI_TRA_TAM":
              badgeColor = "cyan";
              break;
            case "DON_HANG_HOAN_THANH":
              badgeColor = "green";
              break;
            case "DON_HANG_DOI_TRA":
              badgeColor = "green";
              break;
            case "THANH_TOAN_CHUA_HOAN_THANH":
              badgeColor = "red";
              break;
            case "pending":
              badgeColor = "yellow";
              break;
            case "DON_HANG_BAN_TAI_SHOP":
              badgeColor = "green";
              break;
            case "DON_HANG_CHO_DUYET_GIAM":
              badgeColor = olive_green.light;
              break;
            case "DON_HANG_DA_DUYET_GIAM":
              badgeColor = olive_green.medium;
              break;
            case "KHO_XUAT_HANG":
              badgeColor = sky_blue.medium;
              break;
            case "DON_HANG_DONG":
              badgeColor = "red";
              break;
            default:
              badgeColor = "gray";
          }
          return (
            <Badge
              size="md"
              color={badgeColor}
              fs={"12,5px"}
              fw={"bold"}
              radius="sm"
            >
              {row.original.orderStatus !== null
                ? getTextStatus(row)
                : "Không HỢP LỆ"}
            </Badge>
          );
        },
      },
      {
        accessorKey: "attribute58",
        header: "Trạng thái đơn hàng TMĐT",
        size: 240,
        Cell: ({ renderedCellValue }) => (
          <Text size="sm" fw={500} tt={"uppercase"}>
            {getDataAtt58(renderedCellValue?.toString() ?? "")}
          </Text>
        ),
      },
      {
        accessorKey: "trangThaiDoiSoat",
        header: "Trạng thái đối soát",
        Cell: ({ row }) =>
          String(row.original.saleChannelId) === "341" ? (
            row.original.attributeValue7 && row.original.attributeValue7 > 0 ? (
              <Badge color="green">Đã đối soát</Badge>
            ) : (
              <Badge color="orange">Chưa đối soát</Badge>
            )
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "attribute12",
        header: "Trạng thái chung",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {getValueById(
              renderedCellValue?.toString() ?? "",
              dataStatusGeneral,
              "label",
            )?.toUpperCase() || renderedCellValue}
          </Text>
        ),
      },
      {
        accessorKey: "attribute53",
        header: "Trạng thái phân công",
        enableColumnFilter: false,
        size: 200,
        Cell: ({ renderedCellValue }) => (
          <Text size="sm" fw={500} tt={"uppercase"}>
            {renderedCellValue === "CHUA_PHAN_CONG"
              ? "Chưa phân công"
              : renderedCellValue === "DA_PHAN_CONG"
                ? "Đã phân công"
                : renderedCellValue === "DA_TIEP_NHAN"
                  ? "Đã tiếp nhận"
                  : ""}
          </Text>
        ),
      },
      {
        accessorKey: "attribute3",
        header: "Trạng thái kho",
        Cell: ({ renderedCellValue, row }) => {
          const _status = warehouseStatus.find(
            (status) => status.value === row?.original?.attribute3?.toString(),
          );

          return (
            <Badge size="sm" color="cyan">
              {_status?.label ? _status.label : "Chưa yêu cầu"}
            </Badge>
          );
        },
      },
      {
        accessorKey: "attribute37",
        header: "Ngày xuất kho",
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <>{formatDateTransfer(undefined)}</>;
        },
      },
      {
        accessorKey: "orderType",
        header: "Loại đơn hàng",
        size: 150,
        // // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          const orderType = orderTypes.find(
            (type) => type.value === row.original.orderType?.toString(),
          );

          return (
            <Badge color={orderType?.color || "gray"}>
              {orderType?.label || "KHÔNG HỢP LỆ"}
            </Badge>
          );
        },
      },
      {
        accessorKey: "attribute16",
        header: "Mã ĐTCN",
        size: 150,
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "saleChannelId",
        header: "Kênh bán",
        Cell: ({ renderedCellValue }) => {
          const saleChannel = dataChannel.find(
            (channel) => channel.value === renderedCellValue?.toString(),
          );
          return saleChannel?.text || "KHÔNG HỢP LỆ";
        },
      },

      {
        accessorKey: "invOrgName",
        header: "Kho hàng",
        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ row, column }) => (
          <>{`[${row.original.invOrgCode}] ${row.original.invOrgName}`}</>
        ),
      },
      {
        accessorKey: "sale",
        header: "Nhân viên bán hàng",
        size: 180,
        // enableColumnActions: false,,
        enableColumnFilter: false,
        // Cell: ({ renderedCellValue }) => (
        //   <>
        //     <AvatarUtils
        //       value={renderedCellValue?.toString().split("-")[0] ?? ""}
        //     />
        //   </>
        // ),
      },
      {
        accessorKey: "nvhs",
        header: "Người hưởng số",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "salePhone",
        header: "Số đt người bán",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },

      {
        accessorKey: "creator",
        header: "Người tạo đơn đổi trả",
        // enableColumnActions: false,,
        size: 200,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          // Kiểm tra nếu orderType === 3 thì hiển thị, ngược lại không hiển thị
          return row.original.orderType == 3 ? <>{row.original.creator}</> : "";
        },
      },
      // {
      //   accessorKey: "attribute18",
      //   header: "Người hưởng doanh số",
      //   // enableColumnActions: false,,
      //   enableColumnFilter: false,
      //   Cell: ({ renderedCellValue }) => (
      //     <>
      //       <AvatarUtils
      //         value={renderedCellValue?.toString().split("-")[0] ?? ""}
      //       />
      //     </>
      //   ),
      // },
      {
        accessorKey: "creationDate",
        header: "Ngày lập",
        size: 160,
        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <>{formatDateTransfer(undefined)}</>;
        },
      },
      {
        accessorKey: "orderDate",
        header: "Ngày hoàn thành",
        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <>{formatDateTransfer(undefined)}</>;
        },
      },
      // {
      //   accessorKey: "address",
      //   header: "Địa chỉ",
      //   // enableColumnActions: false,,
      //   enableColumnFilter: false,
      // },
      {
        accessorKey: "technicalChecked",
        header: "Dịch vụ kiểm tra",
        // enableColumnActions: false,,
        enableColumnFilter: false,
        size: 200,
        Cell: ({ row }) => (
          <>
            {
              <>
                {(() => {
                  if (row.original.technicalChecked === 0) {
                    return <Badge color="indigo">Không yêu cầu</Badge>;
                  } else if (row.original.technicalChecked === 1) {
                    return <Badge color="grape">Lắp ráp(mới)</Badge>;
                  } else if (row.original.technicalChecked === 2) {
                    return <Badge color="cyan">Kiểm tra(mới)</Badge>;
                  } else if (row.original.technicalChecked === 3) {
                    return (
                      <Badge color={sky_blue.medium}>
                        Lắp ráp(mới)+Kiểm tra(mới)
                      </Badge>
                    );
                  } else {
                    return null; // Or any fallback UI if needed
                  }
                })()}
              </>
            }
          </>
        ),
      },
      {
        accessorKey: "attribute11",
        header: "KT đã kiểm tra",
        size: 260,
        Cell: ({ row }) => (
          <Badge color="blue">
            {row?.original?.attribute11
              ? row?.original?.attribute11
              : "Khách không yêu cầu kiểm tra"}
          </Badge>
        ),
      },
      {
        accessorKey: "deliveryStatus",
        header: "Trạng thái giao vận",
        Cell: ({ renderedCellValue }) => (
          <Text size="sm" fw={500} tt={"uppercase"}>
            {getDataDeliveryStatus(renderedCellValue?.toString() ?? null)}
          </Text>
        ),
      },
      {
        accessorKey: "shipingVendor",
        header: "Bộ phận giao hàng",
        // enableColumnActions: false,
        enableColumnFilter: false,
        Cell: ({ row, column }) => (
          <>{getShippingVendorText(row?.original?.shipingVendor ?? "")}</>
        ),
      },
      {
        accessorKey: "tenNVGV",
        header: "Tên NV giao vận",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "sdtNVGV",
        header: "SĐT NV giao vận",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "attribute46",
        header: "Thời gian GV tiếp nhận đơn",
        enableColumnFilter: false,
        size: 225,
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <>{formatDateTransfer(undefined)}</>;
        },
      },
      {
        accessorKey: "attribute45",
        header: "Thời gian GV hoàn thành đơn",
        enableColumnFilter: false,
        size: 240,
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <>{formatDateTransfer(undefined)}</>;
        },
      },

      {
        accessorKey: "customerName",
        header: "Tên khách hàng",
        // enableColumnActions: false,,
        enableColumnFilter: false,
        // Cell: ({ renderedCellValue, cell }) => (
        //   <Badge radius="xs" variant="light" leftSection={<IconPhoneCall />}>
        //     {renderedCellValue}
        //   </Badge>
        // ),
      },
      {
        accessorKey: "customerPhone",
        header: "Điện thoại KH",
        size: 160,
        // enableColumnActions: false,,
        enableColumnFilter: false,
        // Cell: ({ renderedCellValue, cell }) => (
        //   <Badge radius="xs" variant="light" leftSection={<IconPhoneCall />}>
        //     {renderedCellValue}
        //   </Badge>
        // ),
      },
      // {
      //   accessorKey: "htttPriority",
      //   header: "HTTT dự kiến",
      // },
      {
        accessorKey: "totalAmount",
        header: "Tổng tiền hàng",
        size: 160,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          let listAdd = row.original.orderDetail || [];
          let priceTotal = 0;
          listAdd?.forEach((item: any) => {
            priceTotal += (item?.priceOnPriceList || 0) * (item?.quality || 0);
          });
          return (
            <NumberFormatter
              value={priceTotal}
              thousandSeparator="."
              decimalSeparator=","
            />
          );
        },
      },
      {
        accessorKey: "totalPromotion",
        header: "Giảm giá",
        size: 160,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          let listAdd = row.original.orderDetail || [];
          const totalDiscount = listAdd.reduce((acc: number, item: any) => {
            const discountAmount = item.discountAmount || 0;
            return acc + discountAmount * (item.quality || 1);
          }, 0);
          const totalDiscountRate = listAdd.reduce((acc: number, item: any) => {
            const discountRate = item.discountRate || 0;
            const price = item.priceOnPriceList || 0;
            const quality = item.quality || 1;
            const discountValue = (discountRate / 100) * price * quality;
            return acc + discountValue;
          }, 0);
          const totalPromotionOrder = totalDiscount + totalDiscountRate;
          return (
            <NumberFormatter
              value={totalPromotionOrder}
              thousandSeparator="."
              decimalSeparator=","
            />
          );
        },
      },
      {
        accessorKey: "amountAfterDiscount",
        header: "Sau giảm giá",
        size: 160,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          let listAdd = row.original.orderDetail || [];
          let priceTotal = 0;
          listAdd?.forEach((item: any) => {
            priceTotal += (item?.priceOnPriceList || 0) * (item?.quality || 0);
          });
          const totalDiscount = listAdd.reduce((acc: number, item: any) => {
            const discountAmount = item.discountAmount || 0;
            return acc + discountAmount * (item.quality || 1);
          }, 0);
          const totalDiscountRate = listAdd.reduce((acc: number, item: any) => {
            const discountRate = item.discountRate || 0;
            const price = item.priceOnPriceList || 0;
            const quality = item.quality || 1;
            const discountValue = (discountRate / 100) * price * quality;
            return acc + discountValue;
          }, 0);
          const totalPromotionOrder = totalDiscount + totalDiscountRate;
          const displayTotalAmount = priceTotal;
          const amountAfterDiscount = Math.max(
            displayTotalAmount - totalPromotionOrder,
            0,
          );
          return (
            <NumberFormatter
              value={amountAfterDiscount}
              thousandSeparator="."
              decimalSeparator=","
            />
          );
        },
      },
      {
        accessorKey: "amountDiscountTotal",
        header: "Tổng phí sàn",
        size: 160,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          let listAdd = row.original.orderDetail || [];
          let sumAttr28 = listAdd.reduce(
            (sum: number, item: any) => sum + (Number(item.attribute28) || 0),
            0,
          );
          const totalFloorFee =
            Number(row.original.amountDiscountTotal ?? 0) || sumAttr28 || 0;
          return (
            <NumberFormatter
              value={totalFloorFee === 0 ? 0 : `-${Math.abs(totalFloorFee)}`}
              thousandSeparator="."
              decimalSeparator=","
            />
          );
        },
      },
      {
        accessorKey: "attributeValue7",
        header: "Phí sàn cập nhật sau",
        size: 160,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          let floorFeeAfter = Number(
            row.original.attributevalue7 ??
              row.original.attributeValue7 ??
              row.original.attribute17 ??
              0,
          );
          if (isNaN(floorFeeAfter)) floorFeeAfter = 0;
          return (
            <NumberFormatter
              value={floorFeeAfter === 0 ? 0 : `-${Math.abs(floorFeeAfter)}`}
              thousandSeparator="."
              decimalSeparator=","
            />
          );
        },
      },
      {
        accessorKey: "amount",
        header: "Số tiền cần thanh toán",
        size: 160,

        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue, cell }) => (
          <NumberFormatter
            value={(renderedCellValue as string | number) || 0}
            // suffix=" ₫"
            thousandSeparator="."
            decimalSeparator=","
          />
        ),
      },
      {
        accessorKey: "paid",
        header: "Đã trả",
        size: 160,

        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue, cell }) => (
          <NumberFormatter
            value={(renderedCellValue as string | number) || 0}
            // suffix="₫"
            thousandSeparator="."
            decimalSeparator=","
          />
        ),
      },
      {
        accessorKey: "remaining",
        header: "Còn nợ",
        size: 160,
        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue, cell }) => (
          <NumberFormatter
            value={(renderedCellValue as string | number) || 0}
            // suffix=" ₫"
            thousandSeparator=","
          />
        ),
      },
      {
        accessorKey: "attribute39",
        header: "Mã voucher",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "attribute27",
        header: "Số hóa đơn",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "printInvoiceCheck",
        header: "Xuất hóa đơn",
        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ row }) => <>{row.original.printInvoiceCheck}</>,
      },

      // {
      //   accessorKey: "lastEditor",
      //   header: "Người chỉnh sửa cuối cùng",
      //   // enableColumnActions: false,,
      //   enableColumnFilter: false,
      // },

      {
        accessorKey: "attribute60",
        header: "Lý do hủy đơn",
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        // enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        size: 190,
        Cell: ({ renderedCellValue, row }) => (
          <Flex gap={10}>
            <Tooltip label="Danh sách sản phẩm trong đơn">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="blue"
                onClick={() =>
                  openModal(
                    row.original.orderDetail,
                    row.original.amount,
                    row.original.orderNumber,
                  )
                }
              >
                <IconEye size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>

            <Tooltip
              label={
                ALLOW_COPY_STATUSES.includes(row.original.orderStatus)
                  ? "Tạo lại đơn hàng"
                  : "Chỉ tạo lại được đơn đã hoàn thành, đã đóng hoặc đã hủy"
              }
            >
              <ActionIcon
                variant="light"
                aria-label="Copy"
                color="grape"
                disabled={
                  !ALLOW_COPY_STATUSES.includes(row.original.orderStatus)
                }
                onClick={() => handleCopyOrder(row.original.orderNumber)}
              >
                <IconCopy size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>

            <Tooltip label="Video giao hàng">
              <ActionIcon
                variant="light"
                aria-label="Video giao hàng"
                color="cyan"
                onClick={() => openVideoModal(row.original.orderNumber)}
              >
                <IconVideo size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <Tooltip label="Tiếp nhận">
                <ActionIcon
                  variant="light"
                  aria-label="Settings"
                  color="green"
                  disabled={
                    row.original.attribute53 === "DA_TIEP_NHAN" ||
                    row.original.orderStatus === "DON_HANG_HUY"
                  }
                  onClick={() => {
                    const orderHeaderId =
                      row.original.orderDetail?.[0]?.orderHeaderId;
                    if (orderHeaderId) {
                      handleAcceptNV(orderHeaderId); // Truyền orderHeaderId vào hàm onModalAssignNv
                    } else {
                      console.error("orderHeaderId không tồn tại");
                    }
                  }}
                >
                  <IconHandClick size={20} stroke={1.5} />
                </ActionIcon>
              </Tooltip>

              {row.original.orderStatus === "DON_HANG_HOAN_THANH" &&
              row.original.attribute30 !== "1" ? (
                <CloseOrderButton
                  row={row}
                  fetchData={() => fetchData()}
                ></CloseOrderButton>
              ) : (
                <>
                  {row.original.orderStatus !== "DON_HANG_HUY" &&
                  row.original.orderStatus !== "KHO_XUAT_HANG" &&
                  row.original.orderStatus !== "DON_HANG_DOI_TRA" &&
                  row.original.orderStatus !== "DON_HANG_DOI_TRA_TAM" ? (
                    <>
                      {row.original.orderStatus === "DON_HANG_TAM" && (
                        <Tooltip label="Sửa đơn">
                          <ActionIcon
                            disabled={
                              row.original.orderStatus ===
                                "DON_HANG_HOAN_THANH" ||
                              row.original.orderStatus === null ||
                              row.original.attribute53 === "CHUA_PHAN_CONG" ||
                              row.original.attribute53 === "DA_PHAN_CONG"
                            }
                            variant="light"
                            aria-label="Settings"
                            color="yellow"
                          >
                            <IconEdit
                              size={20}
                              onClick={() => {
                                handleCheckEdit(row);
                              }}
                            />
                          </ActionIcon>
                        </Tooltip>
                      )}

                      {(row.original.orderStatus === "DON_HANG_CHOT" ||
                        row.original.orderStatus ===
                          "DON_HANG_DA_DUYET_GIAM") && (
                        <Tooltip label="Thanh toán">
                          <ActionIcon
                            disabled={
                              row.original.orderStatus ===
                                "DON_HANG_HOAN_THANH" ||
                              row.original.orderStatus === null
                            }
                            variant="light"
                            aria-label="Settings"
                            color="green"
                          >
                            <IconBrandVisa
                              size={20}
                              onClick={() => {
                                handleCheckPayment(row);
                              }}
                            />
                          </ActionIcon>
                        </Tooltip>
                      )}
                      {(row.original.discountAdded > 0 ||
                        row.original.discountAddedTotal > 0) &&
                        row.original.approveStatus !== 1 &&
                        row.original.orderStatus ===
                          "DON_HANG_CHO_DUYET_GIAM" && (
                          <Tooltip label="Duyệt giảm">
                            <ActionIcon
                              disabled={
                                row.original.orderStatus ===
                                  "DON_HANG_HOAN_THANH" ||
                                row.original.orderStatus === null
                              }
                              variant="light"
                              aria-label="Settings"
                              color="violet"
                              onClick={() => {
                                handleCheckApproved(row);
                              }}
                            >
                              <IconCoin size={20} onClick={() => {}} />
                            </ActionIcon>
                          </Tooltip>
                        )}
                    </>
                  ) : null}

                  {row.original.orderStatus !== "DON_HANG_HUY" &&
                  row.original.orderStatus !== "KHO_XUAT_HANG" &&
                  row.original.orderStatus !== "DON_HANG_DOI_TRA" &&
                  row.original.orderStatus !== "DON_HANG_DONG" ? (
                    <Tooltip
                      disabled={
                        row.original.orderStatus === "DON_HANG_HOAN_THANH"
                      }
                      label="Hủy đơn"
                    >
                      <ActionIcon
                        variant="light"
                        aria-label="Settings"
                        color="red"
                        disabled={
                          row.original.orderStatus === "DON_HANG_HOAN_THANH"
                        }
                        onClick={async () => {
                          DeleteCancelOrder(
                            row.original.orderNumber,
                            row.original.orderStatus,
                          );
                        }}
                      >
                        <IconSquareXFilled size={20} stroke={1.5} />
                      </ActionIcon>
                    </Tooltip>
                  ) : null}
                </>
              )}
            </Box>
          </Flex>
        ),
      },
    ],
    [location.pathname],
  );

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    positionToolbarAlertBanner: "bottom",
    renderTopToolbarCustomActions: ({ table }) => <></>,
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT", "orderNumber"],
        right: ["action"],
        // ...columnPinning,
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    enableExpanding: false,
    // onRowSelectionChange: setRowSelection,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      // showAlertBanner: isError,
      // showProgressBars: isRefetching,
      showSkeletons: isLoading,
      sorting,
      rowSelection,
      // columnPinning,
    },
    // onColumnPinningChange: (newState) => {
    //   setColumnPinning(newState);
    // },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    // displayColumnDefOptions: {
    //   "mrt-row-select": {
    //     size: 1,
    //   },
    //   "mrt-row-expand": {
    //     size: 1,
    //   },
    // },
  });

  // Hàm gọi API chi nhánh
  const fetchDataBranch = async () => {
    const dataApi = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmInventory/get-select-branch",
    );

    if (dataApi && dataApi.success) {
      const filteredData = dataApi.data.slice(1);
      setDataBranch(filteredData);
    }
  };

  const ExportExcel = async () => {
    const search = form.getValues();
    const queryParams = {
      Skip: pagination.pageIndex * pagination.pageSize,
      Take: pagination.pageSize,
      InvId: search.invId ? search.invId.toString() : "",
      InvOutwardId: search.invOutwardId ? search.invOutwardId.toString() : "",
      CustomerId: search.customerId ? search.customerId.toString() : "",
      StartDate: search.StartDate
        ? moment(search?.StartDate).format("YYYY-MM-DDT00:00:00.000[Z]")
        : "",
      EndDate: search.StartDate
        ? moment(search?.EndDate).format("YYYY-MM-DDT00:00:00.000[Z]")
        : "",
      OrderStatus: search.orderStatus,
      OrderType: search.orderType ? search.orderType : 0,
      OrderNumber: search.orderNumber,
      PaymentStatus: search.paymentStatus,
      industry: search.industry,
      OutwardStatus: search?.OutwardStatus,
      KeySearch: search.keySearch,
      saleChannelId: search.saleChannelId
        ? search.saleChannelId.toString()
        : "",
      AttributeValue7: search.AttributeValue7,
      Attribute58: search.Attribute58, // Trạng thái đơn hàng TMĐT
      Attribute12: search.Attribute12, // Trạng thái chung
    };

    let url;
    url =
      "/api/v1/CreateSellItem/export-sale-order-tmdt?IsOnline=false&IsInstallment=false&IsAccountant=false&IsEcommerce=true&" +
      Object.entries(queryParams)
        .filter(([, value]) => value !== undefined && value !== "")
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join("&");

    const _url = BASE_API_POS + url;

    const fullUrl = new URL(_url);

    const token = localStorage.getItem("token");
    open();
    try {
      const response = await fetch(fullUrl.toString(), {
        method: "GET", // Use the appropriate HTTP method
        headers: {
          Authorization: `Bearer ${token?.replace(/"/g, "")}`,
          "Content-Type": "application/vnd.ms-excel",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch the resource");
      }

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const _name = new Date().toISOString().slice(0, 10);
      const filename = `bao_cao_ban_hang-${_name}.xlsx`; // Tên mặc định nếu không có header
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      close();
    }
  };

  useEffect(() => {
    fetchData();
  }, [
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    deleteViewStatus,
    refreshKeySearch,
  ]);

  useEffect(() => {
    SocketExtension.On(CREATEORDERSUCCESS, (arg: any) => {
      // fetchData();
      setIsHaveNewOrder(true);
    });
    return () => {
      SocketExtension.Off(CREATEORDERSUCCESS, () => {});
    };
  }, []);

  const renderSelectOption: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={orderTypes.find((x) => x.value === option.value)?.color}
        radius="sm"
        variant="filled"
      ></Badge>
      {option.label}{" "}
      {checked && <IconCheck style={{ marginInlineStart: "auto" }} />}
    </Group>
  );

  // // Lấy key search vào ở local storage
  const [isPending, startTransition] = useTransition();

  useEffect(() => {
    startTransition(() => {
      fetchDataBranch();
    });
  }, []);

  useEffect(() => {
    if (!checkedPinSearch) {
      form.setValues((prev) => ({ ...prev, keySearch: "" }));
    }
  }, [checkedPinSearch]);
  useHotkeys([["Enter", () => fetchData()]]);

  useEffect(() => {
    const fetchEmployeeBy = async () => {
      const response = await repositoryPos.get<MessageResponse<any>>(
        `/api/v1/TblDmEmployee/get-all`,
      );
      if (response && response.success) {
        const result = response.data;
        const formattedData = result.map((employee: any) => ({
          value: employee.code, // Giá trị cho "value"
          label: `${employee.fullname}-${employee.code}`, // Giá trị cho "label"
        }));
        // Lọc trùng theo "value": mỗi value chỉ giữ lại 1 object đầu tiên
        const uniqueData = Array.from(
          new Map(
            formattedData.map((item: any) => [item.value, item]),
          ).values(),
        );
        setListEmployeeSales(uniqueData); // Lưu mảng đã format (đã lọc trùng) vào state
      }
    };
    fetchEmployeeBy();
  }, []);

  return (
    <Box pos={"relative"}>
      <LoadingOverlayCustom visible={visible} />
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        <Flex
          gap="md"
          justify={"space-between"}
          align="center"
          direction="row"
          wrap="wrap"
          w={"100%"}
        >
          <_breadcrumb></_breadcrumb>
          <div>
            <Button
              leftSection={<IconReload size={14} />}
              variant="blue"
              disabled={!isHaveNewOrder}
              mr={"xs"}
              onClick={() => {
                fetchData();
                setIsHaveNewOrder(false);
              }}
            >
              Cập nhật đơn mới
            </Button>
            <Button
              leftSection={<IconDownload size={14} />}
              color="violet"
              variant="outline"
              onClick={async () => ExportExcel()}
            >
              Export Excel
            </Button>
          </div>
        </Flex>
        <Grid mt={"10px"}>
          <Grid.Col span={sizeGrid}>
            <TextInput
              key={form.key("keySearch")}
              placeholder="Từ khoá"
              leftSection={<IconSearch color="#15aabf" />}
              {...form.getInputProps("keySearch")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <TextInput
              key={form.key("codeCustomer")}
              placeholder="Mã khách hàng"
              leftSection={<IconSearch color="#15aabf" />}
              {...form.getInputProps("codeCustomer")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <TextInput
              key={form.key("phone")}
              placeholder="SĐT khách hàng và người mua hàng"
              leftSection={<IconSearch color="#15aabf" />}
              {...form.getInputProps("phone")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <TextInput
              key={form.key("orderNumber")}
              placeholder="Mã đơn hàng"
              leftSection={<IconSearch color="#15aabf" />}
              {...form.getInputProps("orderNumber")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <Select
              key={form.key("orderType")}
              searchable
              clearable
              placeholder="Loại đơn hàng"
              comboboxProps={{
                transitionProps: { transition: "fade-up", duration: 200 },
              }}
              leftSection={<IconMenuOrder color="#15aabf" />}
              data={orderTypes}
              nothingFoundMessage="Dữ liệu không có !"
              renderOption={renderSelectOption}
              {...form.getInputProps("orderType")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              key={form.key("orderStatus")}
              placeholder="Trạng thái đơn hàng"
              clearable
              leftSection={<IconStatusChange color="#15aabf" />}
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              data={orderStatuses}
              {...form.getInputProps("orderStatus")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              key={dataBranch.length || form.key("invId")}
              searchable
              clearable
              placeholder="Chi nhánh"
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              leftSection={<IconBrandBootstrap color="#15aabf" />}
              data={dataBranch.map((item) => {
                return {
                  label: item.text,
                  value: item.value,
                };
              })}
              {...form.getInputProps("invId")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              key={listEmployeeSales.length || form.key("CodeSal")}
              placeholder="Tìm người hưởng số"
              data={listEmployeeSales}
              {...form.getInputProps("CodeSal")}
              // onChange={(value) => {
              //   handleChangeSearchReturn(String(value || ""), "CodeSal");
              // }}
              leftSection={<IconSearch color="#15aabf" />}
              clearable
              searchable
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              type="default"
              key={form.key("StartDate")}
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              size="sm"
              placeholder="Từ ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              {...form.getInputProps("StartDate")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              key={form.key("EndDate")}
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              size="sm"
              placeholder="Đến ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              {...form.getInputProps("EndDate")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              key={form.key("FinishDate")}
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              size="sm"
              placeholder="Thời gian hoàn thành đơn"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              {...form.getInputProps("FinishDate")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              key={form.key("OwDate")}
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              size="sm"
              placeholder="Ngày xuất kho"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              {...form.getInputProps("OwDate")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <TextInput
              key={form.key("VourcherCode")}
              placeholder="Mã vourcher"
              leftSection={<IconSearch color="#15aabf" />}
              {...form.getInputProps("VourcherCode")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <TextInput
              key={form.key("SalePhone")}
              placeholder="SĐT người bán"
              leftSection={<IconSearch color="#15aabf" />}
              {...form.getInputProps("SalePhone")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              key={form.key("IsAssigned")}
              placeholder="Tình trạng phân công"
              data={[
                { label: "Đơn đã được phân công", value: "true" },
                { label: "Đơn chưa được phân công", value: "false" },
              ]}
              leftSection={<IconActivity color="#15aabf" />}
              {...form.getInputProps("IsAssigned")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              key={form.key("AttributeValue7")}
              placeholder="Trạng thái đối soát"
              leftSection={<IconChecklist color="#15aabf" />}
              data={[
                { label: "Đã đối soát", value: "true" },
                { label: "Chưa đối soát", value: "false" },
              ]}
              {...form.getInputProps("AttributeValue7")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              key={form.key("saleChannelId")}
              placeholder="Kênh bán"
              leftSection={<IconSandbox color="#15aabf" />}
              data={[
                { label: "Lazada", value: "304" },
                { label: "Tiktok", value: "341" },
                { label: "Chat Zalo", value: "343" },
                { label: "Facebook", value: "62" },
                { label: "Shopee Mall", value: "63" },
                { label: "Shopee", value: "342" },
                { label: "Tổng đài", value: "66" },
                { label: "Khách đến showroom", value: "67" },
                { label: "Khách đặt đơn Website", value: "68" },
                { label: "Khách gọi điện cho nhân viên", value: "69" },
                { label: "Khách chat qua website", value: "101" },
              ]}
              {...form.getInputProps("saleChannelId")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              key={form.key("Attribute58")}
              placeholder="Trạng thái đơn hàng TMĐT"
              clearable
              searchable
              leftSection={<IconStatusChange color="#15aabf" />}
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              data={[
                { label: "Mới", value: "0" },
                { label: "Chờ xác nhận", value: "17" },
                { label: "Chờ lấy hàng", value: "CHO_LAY_HANG" },
                { label: "Chờ hàng", value: "11" },
                { label: "Chờ in", value: "12" },
                { label: "Đã in", value: "13" },
                { label: "Đã đặt hàng", value: "20" },
                { label: "Đã xác nhận", value: "1" },
                { label: "Đang đóng hàng", value: "8" },
                { label: "Chờ chuyển hàng", value: "9" },
                { label: "Đã gửi hàng", value: "2" },
                { label: "Đã nhận", value: "3" },
                { label: "Đã thu tiền", value: "16" },
                { label: "Đang hoàn", value: "4" },
                { label: "Hoàn một phần", value: "15" },
                { label: "Đã hoàn", value: "5" },
                { label: "Đã huỷ", value: "6" },
                { label: "Đã xoá", value: "7" },
              ]}
              {...form.getInputProps("Attribute58")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              key={form.key("Attribute12")}
              placeholder="Trạng thái chung"
              clearable
              searchable
              leftSection={<IconStatusChange color="#15aabf" />}
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              data={dataStatusGeneral}
              {...form.getInputProps("Attribute12")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <Button
              leftSection={<IconSearch size={14} />}
              color="blue"
              variant="outline"
              loading={isLoading}
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </Box>
  );
};

export default ListOrderTMDTV2;
